import { useEffect, useState } from "react";
import Cookies from "js-cookie";

const empty = { keyman: null, co_owners: [], loading: false, error: "" };
export default function usePropertyMyinfoProfiles(
  applicationId,
  support = false,
) {
  const [state, setState] = useState(empty);
  const token = Cookies.get(support ? "support_token" : "token");
  useEffect(() => {
    if (!applicationId) return;
    let disposed = false;
    let pending = false;
    const controller = new AbortController();
    setState({ ...empty, applicationId, loading: true });
    const refresh = async () => {
      if (pending || document.visibilityState === "hidden") return;
      pending = true;
      try {
        const prefix = support
          ? "support/property-applications"
          : "propTermLoan";
        const response = await fetch(
          `https://www.smart-lend.com/api/${prefix}/${applicationId}/myinfo-profiles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
            signal: controller.signal,
          },
        );
        if (disposed) return;
        const body = await response.json();
        if (!response.ok)
          throw new Error(
            body.message || "Unable to load co-owner Myinfo profiles.",
          );
        if (!disposed)
          setState({
            applicationId,
            loading: false,
            error: "",
            keyman: body.keyman || null,
            co_owners: Array.isArray(body.co_owners)
              ? body.co_owners.filter(person => support || person.review_status === "approved")
              : [],
          });
      } catch (error) {
        if (!disposed)
          setState({ ...empty, applicationId, error: error.message });
      } finally {
        pending = false;
      }
    };
    refresh();
    const timer = setInterval(refresh, 15000);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      disposed = true;
      controller.abort();
      clearInterval(timer);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [applicationId, support, token]);
  return applicationId && state.applicationId === applicationId ? state : empty;
}
